import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/layouts/Navbar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/components/products/product-list.tsx");
